import { getContext, setContext, tick } from 'svelte'

import { preloadData, replaceState as svelteReplaceState, pushState as sveltePushState, goto } from '$app/navigation'
import { page } from '$app/state'

const CONTEXT = Symbol('PAGE-STATE')

export function createPageStateContext(): PageStateContext {
      return setContext(CONTEXT, new PageStateContext())
}

export function getPageStateContext(): PageStateContext {
      return getContext(CONTEXT)
}

export class PageStateContext {
      init = false
      state = $derived( page.state )

      constructor() {
            this.initContext()
            return this
      }


      async initContext() {
            await tick()
            this.init = true
            return this
      }

      replaceState(key: string, state: any, url: string = '') {
            if (!this.init) return

            svelteReplaceState(url, {
                  ...page.state,
                  [key]: state,
            })

            return page.state
      }

      pushState(key: string, state: any, url: string = '') {
            if (!this.init) return

            sveltePushState(url, {
                  ...page.state,
                  [key]: state,
            })

            return page.state
      }

      getState(key: string) {
            return page.state[key] ?? undefined
      }

      goBack() {
            history.back()
            return page.state
      }
}
